<template>
  <v-card>
    <v-card-title class='justify-center'>
      <h2>USAR CRÉDITO</h2>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout
        justify-space-around
        wrap
        style='font-size: 1.2em'
        class='mb-4'
      >
        <v-flex xs5>
          <h4>Placa: {{ credito.veiculo }}</h4>
        </v-flex>
        <v-flex xs5>
          <h4>Empresa: {{ credito.proposta.empresa.nome_fantasia }}</h4>
        </v-flex>
        <v-flex xs5>
          <h4>
            Valor Disponível:
            {{ credito.valor_disponivel | currency({ fractionCount: 2 }) }}
          </h4>
        </v-flex>
        <v-flex xs5>
          <h4>CNPJ: {{ credito.proposta.empresa_id }}</h4>
        </v-flex>
      </v-layout>
      <h3 class='text-xs-center'>
        Selecione o funcionário que está abastecendo
      </h3>
      <v-select
        label='Selecione o funcionário que está abastecendo'
        outline
        v-model='funcionarioSelecionado'
        :items='funcionarios'
        item-text='nome_email'
        return-object
        required
      >
        <template v-slot:item='props'>
          {{
            props.item.pessoa
              ? `${props.item.pessoa.nome_completo}`
              : props.item.nome_email
          }}
        </template>
      </v-select>
      <v-layout wrap justify-space-between class='mt-4'>
        <v-flex xs8>
          <v-select
            label='Selecione o combustível'
            outline
            v-model='combustivelSelecionado'
            :items='combustiveis'
            item-text='nome'
            item-value='id'
            required
            :disabled='!!credito.proposta.item'
            return-object
          >
            <template v-slot:item='props'>
              <v-tooltip right>
                <template
                  v-slot:activator='{ on }'
                  v-if='props.item'
                >
                  <svg-filler
                    v-on='on'
                    :path='
                      props.item
                        ? require(`@/assets/combs/${props.item.combustivel.icone}.svg`)
                        : require(`@/assets/combs/gas.svg`)
                    '
                    width='40px'
                    height='40px'
                    :fill="
                      props.item.combustivel ? props.item.combustivel.color : ''
                    "
                  />
                </template>

                <span>{{
                  props.item.combustivel
                    ? props.item.combustivel.nome
                    : 'Não informado'
                }}</span>
              </v-tooltip>
              <span>{{ props.item.combustivel.nome }}</span>
            </template>
          </v-select></v-flex
        >
        <v-flex xs3>
          <div
            v-if="valorCombustivel !== ''"
            @click="
              valorCombustivel = ''
              valorCombustivelMoney = '0,00'
              focusPrecoCombustivelField()
            "
          >
            <v-text-field
              label='Preço combustível'
              outline
              v-model='valorCombustivel'
              prefix='R$'
              :rules="[(v) => valorValido(v) || 'Valor Inválido']"
            />
          </div>
          <v-text-field
            v-else
            label='Preço combustível'
            ref='precoCombustivelField'
            outline
            v-model='valorCombustivelMoney'
            prefix='R$'
            v-money='money'
            on:click
            :rules="[(v) => valorValido(v) || 'Valor Inválido']"
        /></v-flex>
      </v-layout>

      <h4>Inserir com:</h4>
      <v-radio-group v-model='isValue' row>
        <v-radio
          label='Valor de Abastecimento'
          :value='true'
          color='primary'
        ></v-radio>
        <v-radio
          label='Quantidade de combustível'
          :value='false'
          color='primary'
        ></v-radio>
      </v-radio-group>
      <v-slide-x-transition>
        <v-text-field
          v-if='isValue'
          label='Valor de Abastecimento'
          outline
          v-model.lazy='valorAbastecimento'
          prefix='R$'
          v-money='money'
          maxlength = '11'
          :rules="[(v) => valorValido(v) || 'Valor Inválido']"
          required
        />
        <v-text-field
          v-else
          :label='texto_qtd'
          outline
          v-model.lazy='quantidade'
          v-money='info_comb'
          maxlength = '11'
          :rules="[(v) => quantidadeValida(v) || 'Valor Inválido']"
          required
        />
      </v-slide-x-transition>
      <v-text-field
        label='Digite o odômetro do veículo'
        outline
        v-model='hodometro'
        type='number'
      />
      <h4>
        Valor Total:
        {{ formatarvalor(valorAbastecimento) | currency({ fractionCount: 2 }) }}
      </h4>
      <h4 v-if='combustivelSelecionado'>
        Quantidade de {{ combustivelSelecionado.combustivel.descricao_volume }}:
        {{ quantidade }} {{ combustivelSelecionado.combustivel.tipo_volume }}
      </h4>
      <h4 v-else-if="valorCombustivelMoney !== '0,00'">
        Quantidade de Litros {{ quantidade }} L
      </h4>
      <v-tooltip bottom>
        <template v-slot:activator='{ on }'>
          <v-checkbox
            style='
                justify-content: center
                align-items: center
              '
            v-on='on'
            color='primary'
            v-model='finalizar'
            label='Finalizar'
          ></v-checkbox>
        </template>
        <h3>
          {{
            finalizar
              ? 'Esse campo estando marcado, o voucher será gerado já consumido, dispensando a necessidade de realizar a leitura dele.'
              : 'Esse campo não estando marcado, você ainda precisará realizar a leitura do voucher que será gerado.'
          }}
        </h3>
      </v-tooltip>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout justify-space-around wrap class='mb-2'>
        <v-flex xs9>
          <h6
            class='mb-2 text-xs-center'
            style='
                        font-size: 1.1em
                        margin-left: 9em
                    '
          >
            Digite o PIN do frentista responsável
          </h6>
        </v-flex>
        <v-flex xs3>
          <v-btn
            round
            color='primary'
            small
            @click='selecionarFrentista = true'
          >
            Alterar frentista
          </v-btn>
        </v-flex>
        <v-flex xs2>
          <v-icon size='40'>engineering</v-icon>
        </v-flex>
        <v-flex xs10>
          <h4>Lido por: {{ frentistaSelecionado.nome }}</h4>
          <h4>Matricula: {{ frentistaSelecionado.matricula }}</h4>
        </v-flex>
      </v-layout>
      <Pin
        v-if='!autenticado'
        :frentista='frentistaSelecionado'
        @autenticado='autenticado = true'
      />
      <h3 v-else class='success--text text-xs-center mt-3 mb-3'>
        A leitura já pode ser realizada
      </h3>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        block
        large
        color='primary'
        :disabled='!autenticado'
        flat
        :loading='loading'
        @click='realizarLeitura'
      >
        Realizar Leitura
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-if='selecionarFrentista'
      v-model='selecionarFrentista'
      fullscreen
      hide-overlay
      transition='dialog-bottom-transition'
    >
      <selecionar-frentista
        @fechar='(selecionarFrentista = false), (autenticado = false)'
      />
    </v-dialog>
  </v-card>
</template>

<script>
import Decimal from 'decimal.js'
import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'
import { VMoney } from 'v-money'
export default {
  components: { Pin, SelecionarFrentista },
  props: ['credito'],
  directives: { money: VMoney },
  data: () => ({
    autenticado: false,
    hodometro: undefined,
    selecionarFrentista: false,
    pessoa: undefined,
    funcionarios: [],
    combustiveis: [],
    funcionarioSelecionado: undefined,
    combustivelSelecionado: undefined,
    finalizar: true,
    carregando: true,
    valorAbastecimento: '0,00',
    valorCombustivel: '',
    valorCombustivelMoney: '0,00',
    isValue: true,
    quantidade: '0,00',
    texto_qtd: 'Quantidade de litros',
    info_comb: {
      decimal: ',',
      thousands: '.',
      precision: 3,
      masked: false
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    }
  }),
  computed: {
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    this.pegarFuncionarios()
    this.carregarItens()
    if (this.posto) {
      if (this.posto.litragem_2_casas) {
        this.info_comb.precision = 2
      }
    }
  },
  watch: {
    valorCombustivel (val) {
      this.valorCombustivel = this.valorCombustivel.split('.').join(',')
    },
    combustivelSelecionado (val) {
      if (val) {
        this.valorCombustivel = Decimal(
          Math.floor(this.combustivelSelecionado.preco * 10 ** 2) / 10 ** 2
        ).toFixed(2)

        let combustivelPreco
        if (this.valorCombustivel === '') combustivelPreco = this.formatarvalor(this.valorCombustivelMoney)
        else combustivelPreco = this.combustivelSelecionado.preco

        this.texto_qtd = 'Quantidade de ' + val.combustivel.descricao_volume
        if (this.valorValido(this.valorAbastecimento) && val) {
          const valor = this.formatarvalor(this.valorAbastecimento)
          if (this.posto.truncamento_combustivel) {
            const preco = new Decimal(
              Math.floor(combustivelPreco * 10 ** 2) / 10 ** 2
            ).toFixed(2)
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          } else {
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          }
        } else {
          if (this.posto.litragem_2_casas) {
            this.quantidade = '0,00'
          } else {
            this.quantidade = '0,000'
          }
        }
      }
    },
    isValue () {
      this.quantidade = null
      this.valorAbastecimento = null
    },
    valorCombustivelMoney (val) {
      if (val) {
        if (this.valorValido(val) && this.valorCombustivel === '') {
          const valor = this.formatarvalor(this.valorAbastecimento)
          let combustivelPreco
          if (this.valorCombustivel === '') combustivelPreco = this.formatarvalor(this.valorCombustivelMoney)
          else combustivelPreco = this.combustivelSelecionado.preco

          if (this.posto.truncamento_combustivel) {
            const preco = new Decimal(
              Math.floor(combustivelPreco * 10 ** 2) / 10 ** 2
            ).toFixed(2)
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          } else {
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          }
        } else {
          if (this.posto.litragem_2_casas) {
            this.quantidade = '0,00'
          } else {
            this.quantidade = '0,000'
          }
        }
      }
    },
    valorAbastecimento (val) {
      if (this.isValue) {
        if (this.valorValido(val)) {
          const valor = this.formatarvalor(val)
          let combustivelPreco
          if (this.valorCombustivel === '') combustivelPreco = this.formatarvalor(this.valorCombustivelMoney)
          else combustivelPreco = this.combustivelSelecionado.preco

          if (this.posto.truncamento_combustivel) {
            const preco = new Decimal(
              Math.floor(combustivelPreco * 10 ** 2) / 10 ** 2
            ).toFixed(2)
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor).dividedBy(preco).toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          } else {
            let qtdCombustivel = 0
            if (this.posto.litragem_2_casas) {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(2)
            } else {
              qtdCombustivel = new Decimal(valor)
                .dividedBy(combustivelPreco)
                .toFixed(3)
            }
            this.quantidade = this.desformatarvalor(qtdCombustivel)
          }
        } else {
          if (this.posto.litragem_2_casas) {
            this.quantidade = '0,00'
          } else {
            this.quantidade = '0,000'
          }
        }
      }
    },
    quantidade (val) {
      if (!this.isValue) {
        if (val) {
          let qtdFormatada = this.formatarvalor(val)
          let combustivelPreco
          if (this.valorCombustivel === '') combustivelPreco = this.formatarvalor(this.valorCombustivelMoney)
          else combustivelPreco = this.combustivelSelecionado.preco
          const preco = combustivelPreco
          const valor = qtdFormatada * preco
          this.valorAbastecimento = this.formatarvalor(valor)
        } else {
          this.valorAbastecimento = '0,00'
        }
      }
    }
  },
  methods: {
    focusPrecoCombustivelField () {
      this.$nextTick(() => this.$refs.precoCombustivelField.focus())
    },
    realizarLeitura () {
      if (!this.funcionarioSelecionado) {
        this.$store.dispatch('setError', {
          message: 'Funcionario não foi selecionado'
        })
        return
      }
      if (!this.combustivelSelecionado) {
        this.$store.dispatch('setError', {
          message: 'O Combustível não foi selecionado'
        })
        return
      }
      if (!this.valorValido(this.valorAbastecimento)) {
        this.$store.dispatch('setError', { message: 'Valor inválido' })
        return
      }
      this.$store
        .dispatch('gerarVoucherComCredito', {
          posto: this.posto.cnpj,
          id_funcionario: this.funcionarioSelecionado.id_funcionario,
          valor: this.formatarvalor(this.valorAbastecimento),
          id_credito: this.credito.id,
          id_item: this.combustivelSelecionado.id,
          id_frentista: this.frentistaSelecionado.id_frentista,
          hodometro: this.hodometro,
          finalizado: this.finalizar,
          quantidade_combustivel: this.formatarvalor(this.quantidade)
        })
        . then(() => {
          this.$emit('fechar')
        })
    },
    formatarvalor (valor) {
      if (!valor) return 0
      if (typeof valor === 'number') return valor
      return Number(valor.replaceAll('.', '').replace(',', '.'))
    },
    desformatarvalor (valor) {
      if (!valor) return '0,00'
      if (typeof valor === 'string') return valor.replaceAll('.', ',')
      return valor.toString().replace(',', '.')
    },
    quantidadeValida (valor) {
      const value = this.formatarvalor(valor)
      return value > 0
    },
    valorValido (valor) {
      const value = this.formatarvalor(valor)
      return value > 0 && value <= this.credito.valor_disponivel
    },
    pegarFuncionarios () {
      this.$store
        .dispatch('pegarFuncionarios', {
          empresa: this.credito.proposta.empresa.cnpj,
          confirmado: true
        })
        .then((json) => {
          this.funcionarios = json
        })
    },
    carregarItens () {
      this.$store.dispatch('carregarItens').then((json) => {
        this.combustiveis = json
        if (this.credito.proposta.item) {
          this.combustiveis.map((item) => {
            if (this.credito.proposta.item.id === item.id) {
              this.combustivelSelecionado = item
            }
          })
        }
      })
    }
  }
}
</script>

<style></style>
